import { FileCollectionGallery } from "../../../components/FileCollectionGallery.tsx";
import { useRecipe } from "../RecipeContext.tsx";

export const RecipePhotosTab = () => {
  const { recipe } = useRecipe();
  return <FileCollectionGallery files={recipe.photos} />;
};
